<h2 mat-dialog-title>Confirm application delete</h2>
<mat-dialog-content class="mat-typography">
 <p>Are you sure you want to delete the {{ data.countryName }} application?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true">Delete</button>
</mat-dialog-actions>
